import React from 'react';
import { Media, Button, Glyphicon, ListGroupItem, Image } from 'react-bootstrap';

function formatBytes(bytes,decimals) {
    if (bytes === 0) return '0 Bytes';
    var k = 1000,
        dm = decimals + 1 || 3,
        sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export default ({ leftImage, Title = "", fileSize = false, modifiedDate = false, createdDate = false, handleDelete, handleCustom, titleCustom = false , ...props }) => (
    <ListGroupItem
        {...props}>
        <Media>
            <Media.Left align="middle">
                <Image src={leftImage}  />
            </Media.Left>
            <Media.Body>
                <h4>
                    {Title}
                </h4>
                <small>
                {(fileSize) &&
                    (
                        <small>
                            { "Size: " + formatBytes(fileSize,1) }
                            <br/>
                        </small>
                    )}
                {(createdDate) &&
                (
                    <p>
                        { "Created: " + (new Date(createdDate)).toLocaleString() }
                        <br/>
                    </p>

                )}
                {(modifiedDate) &&
                (
                    <p>
                        { "Modified: " + (new Date(modifiedDate)).toLocaleString() }
                    </p>
                )}
                </small>
            </Media.Body>
            {(titleCustom) &&
            (
                <Media.Right align="middle">
                    <Button
                        block
                        bsStyle="primary"
                        bsSize="small"
                        disabled={false}
                        onClick={handleCustom}>
                        <Glyphicon glyph="signal" /> {titleCustom}
                    </Button>
                </Media.Right>
            )}
            <Media.Right align="middle">
                <Button
                    block
                    bsStyle="danger"
                    bsSize="small"
                    disabled={false}
                    onClick={handleDelete}>
                    <Glyphicon glyph="trash" /> Delete
                </Button>
            </Media.Right>
        </Media>
    </ListGroupItem>
);


// WEBPACK FOOTER //
// ./src/components/CustomListGroupItem.js